import type {
  ButtonKey,
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "./Button.type";

export const BUTTON_KEYS = {
  DELETE: "delete",
  DUPLICATE: "duplicate",
  DIVIDER: "divider",
  EDIT: "edit",
  EXPORT: "export",
  FAVORITE: "favorite",
  FOLLOW_UP: "followUp",
  FORCE_CHANGE_PASSWORD: "forceChangePassword",
  INFO: "info",
  NEW_FOLLOW_UP: "newFollowUp",
  PROGRESS: "progress",
  RESET: "reset",
  RESTORE: "restore",
  RESEND_INVITE: "resendInvite",
  STATE_EDIT: "stateEdit",
  UPDATE_PASSWORD: "updatePassword",
  USER_ACCESS: "userAccess",
} as const;
export const BUTTON_KEYS_VALUES = Object.values(BUTTON_KEYS) as ButtonKey[]; // TODO: remove this after TS transition (it's use by PropType)

// Careful, couple with AntD button type
export const BUTTON_TYPE = {
  DASHED: "dashed",
  DEFAULT: "default",
  LINK: "link",
  PRIMARY: "primary",
  TEXT: "text",
} as const;
export const BUTTON_TYPE_VALUES = Object.values(BUTTON_TYPE) as ButtonType[]; // TODO: remove this after TS transition (it's use by PropType)

// Careful, couple with antd button shape
export const BUTTON_SHAPE = {
  DEFAULT: "default",
  CIRCLE: "circle",
  ROUND: "round",
} as const;

export const BUTTON_SHAPE_VALUES = Object.values(BUTTON_SHAPE) as ButtonShape[]; // TODO: remove this after TS transition (it's use by PropType)

// Careful, couple with antd button size
export const BUTTON_SIZE = {
  large: "large",
  middle: "middle",
  small: "small",
} as const;

export const BUTTON_SIZE_VALUES = Object.values(BUTTON_SIZE) as ButtonSize[]; // TODO: remove this after TS transition (it's use by PropType)
